module.exports = __webpack_public_path__ + "static/img/03-eFile.39cd88e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/03-eFile.png
// module id = zXZi
// module chunks = 1